import apiService from './apiService';
import { GET } from './executer';

export interface TrackPoint {
  minutes_ahead: number;
  lat: number;
  lon: number;
  distance_km: number;
  uncertainty_radius_km: number | null;
  current_rain_rate_mmh?: number;
}

export interface StormTrackingData {
  timestamp: string;
  rain_detected: boolean;
  rain_at_circuit: boolean;
  is_approaching: boolean;
  direction_deg: number | null;
  cell_bearing_deg: number | null;
  speed_kmh: number | null;
  eta_minutes: number | null;
  nearest_rain_km: number | null;
  max_intensity_dbz: number | null;
  display_rain_rate_mmh: number | null;
  cell_radius_km: number | null;
  closest_approach_km: number | null;
  will_intercept: boolean;
  impact_window_min: [number, number] | null;
  confidence: number;
  track_points: TrackPoint[];
  circuit: { lat: number; lon: number };
}

interface StormTrackingRangeQuery {
  start_timestamp: string; // YYYYMMDDHHmmss (UTC)
  end_timestamp: string;   // YYYYMMDDHHmmss (UTC)
}

class StormTrackingService {
  /**
   * Fetch all storm tracking data within a time range from GCS files.
   * Returns all records in one batch (files are ~3KB each).
   */
  async getStormTrackingRange(query: StormTrackingRangeQuery): Promise<StormTrackingData[]> {
    const { start_timestamp, end_timestamp } = query;

    const queryParams = new URLSearchParams({ start_timestamp, end_timestamp });

    const response = await apiService.client.execute<StormTrackingData[]>(
      GET,
      `/api/storm-tracking-l2?${queryParams.toString()}`
    );

    if (!response.success) {
      console.warn('[StormTrackingService] Failed to fetch storm tracking range:', response);
      return [];
    }

    return response.data ?? [];
  }
}

const stormTrackingService = new StormTrackingService();
export default stormTrackingService;

export type { StormTrackingRangeQuery };
